<template lang="pug">
.asa-feed
  ul.asa-feed-items.asa-content-list
    search-feed-item(
      v-for="(hit, i) in hits"
      :hit="hit"
      :position="i+1"
      :queryID="queryID"
      :aa="aa"
      :index="index"
      :key="hit.wp_id"
      :context="context"
      @clear-cache="$emit('clear-cache')"
    )

  a.asa-feed__read-more.mb-3.d-block(
    :href="`/search/?s=${query}&sortBy=${sortBy}`"
    v-if="query && hits.length > 0 && !isSearchPage"
  ) 
    small View More Results
      span.mdi.mdi-chevron-right

  .mt-4(
    v-if="isSearchPage && showMore"
  )
    button.btn.btn-primary.btn-sm(
      @click="$emit('loadmore')"
    ) More Results
      span.mdi.mdi-chevron-down
</template>

<script>
export default {
  components: {
    'search-feed-item' : () => import('./search-feed-item')
  },
  data(){
    return {
      showMore: false
    }
  },
  props: {
    hits: {
      type: Array
    },
    name: {
      type: String
    },
    query: {
      type: String
    },
    queryID: {
      type: String
    },
    aa: {
      type: Function
    },
    index: {
      type: String
    },
    context: {
      type: String
    },
    isSearchPage: {
      type: Boolean,
      default: false
    },
    algoliaQuery: {
      type: Object
    },
    sortBy: {
      type: String,
      default: 'relevance'
    }
  },
  watch : {
    hits(){
      this.updateShowMore()
    },
    query(){
      this.updateShowMore()
    }
  },
  mounted(){
    this.updateShowMore()
  },
  methods: {
    updateShowMore(){
      if( this.algoliaQuery && this.algoliaQuery.$q ){
        this.showMore = this.algoliaQuery.$q.hasMore();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
ul.asa-feed-items{
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
</style>